import { ApolloError, useQuery } from '@apollo/client'
import { MANAGER_OF_COMPANY_OR_RESPONSIBLE_OF } from '../Queries'
import {
  FindCompaniesAndCountriesByCompanyManagerOrResponsibleQuery,
  FindCompaniesAndCountriesByCompanyManagerOrResponsibleQueryVariables,
} from '../../../types'

export default (): {
  data: FindCompaniesAndCountriesByCompanyManagerOrResponsibleQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<
    FindCompaniesAndCountriesByCompanyManagerOrResponsibleQuery,
    FindCompaniesAndCountriesByCompanyManagerOrResponsibleQueryVariables
  >(MANAGER_OF_COMPANY_OR_RESPONSIBLE_OF)

  return { data, error, loading }
}
